import "../styles/Contacto.css";

const Contacto = () => {
  return (
    <>
      <div className="home p-0">
        <div className="container-cookie bannerInicial">
          <div className="row bannerI">
            <div className="col-12 col-md-6 col-image p-0">
              <div
                className="contacto__image-container"
                style={{ background: "white" }}
              >
                <img
                  src="/assets/img/homeout/img-contacto.png"
                  className="home__image_contact d-none d-lg-inline"
                  alt=""
                />
                <img
                  src="/assets/img/homeout/img-contacto-mobile.png"
                  className="home__image_contact d-lg-none"
                  alt=""
                />
              </div>
            </div>
            <div className="col-12 col-md-6 col-back div__contacto">
              <div className="d-block d-lg-none">
                <h1 className="titulo__contacto">Contáctanos</h1>
              </div>
              <div className="home__text-container container__contacto">
                <div className="card__contacto-item">
                  <div className="card__contacto-img d-none d-lg-block">
                    <img
                      src="/assets/img/homeout/contacto/ico-fono.svg"
                      alt="icono_telefono"
                      className="d-none d-lg-block"
                    />
                  </div>
                  <div className="div__telefono">
                    <p className="card__contacto-description">
                      Si tienes alguna inquietud o consulta, comunícate <br className="d-none d-lg-block"/> con
                      nosotros en nuestra línea de atención en:
                    </p>
                    <div className="d-lg-none d-block">
                      <br />
                    </div>
                    <p
                      className="card__contacto-description container__contacto__tel-mail"
                      style={{
                        color: "var(--rojo)",
                        fontFamily: "var(--fuente-bold)",
                        fontSize: "2rem",
                      }}
                    >
                      <div className="d-lg-block d-none">
                        Línea de atención Cardif:{" "}
                        <span style={{ color: "var(--rojo)" }}>
                          <div className="d-lg-none d-block"></div>800 801 2402
                        </span>
                      </div>
                      <div className="d-lg-none d-block">
                        Línea de atención Cardif:{" "}
                        <a href="tel:8008012402" style={{ color: "var(--rojo)" }}>
                          <div className="d-lg-none d-block"></div>800 801 2402
                        </a>
                        <br />
                      </div>
                      <div className="breakLine"></div><span className="d-none d-lg-inline">Horarios:</span>{" "}
                      <div className="breakLine"></div><span className="d-block d-lg-none">Horarios de atención:</span>{" "}
                      <div className="d-lg-none d-block"></div>Lunes a viernes{" "}
                      <div className="d-lg-none d-block"></div>de 08:00 a 21:00
                      hrs
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contacto;
